import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getAllProperties } from 'modules/_common/api';

export const useQueryProperties = () => {
  const {
    data: properties,
    isLoading: isLoadingProperties,
    isError: isErrorProperties,
  } = useQuery([QUERY_KEYS.SETTINGS_PROPERTIES], getAllProperties, {
    staleTime: 5 * 60 * 1000,
    keepPreviousData: true,
  });

  return { properties, isLoadingProperties, isErrorProperties };
};
